<script src="../plugins/helper.js"></script>
<template>
  <div v-if="readyToUse">
    <v-navigation-drawer
        class="print-hide"
        v-if="!$route.fullPath.startsWith('/admin/print')"
        v-model="drawer"
        fixed
        app
        color="#F0F5F7"
    >
      <v-row>
        <v-col cols="12">
          <router-link to="/admin">
            <img
                class="text-center pa-4"
                width="100%"
                src="@/assets/img/eMatica_logo.svg"
            />
          </router-link>
        </v-col>
      </v-row>

      <v-select
          outlined
          v-model="school_year_id"
          :items="years"
          item-text="title"
          item-value="id"
          color="primary"
          label="Školska godina"
          hide-details
          dense
          class="mx-3 my-3"
          @change="pickedYear"
      ></v-select>


      <v-list shaped>
        <template v-for="item in items">
          <v-row :key="item.heading" align="center" v-if="item.heading">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col class="text-center" cols="6">
              <a class="body-2 black--text" href="#!">EDIT</a>
            </v-col>
          </v-row>

          <v-list-group
              :key="item.text"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
              v-model="item.model"
              v-else-if="item.children && $checkPermission(item.permission)"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="(child, i) in item.children">
              <v-list-item
                  :key="i"
                  link
                  :value="child.link === $route.fullPath"
                  v-if="$checkPermission(child.permission)"
                  @click="navigate(child)"
              >
                <div>
                  <v-list-item-action v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title style="white-space: normal; word-wrap: break-word; max-width: 200px;">{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </div>
              </v-list-item>
            </template>
          </v-list-group>

          <v-list-item
              :key="item.text"
              :value="item.link === $route.fullPath"
              @click="
              navigate(item);
              getDemands();
            "
              :style="{
              'background-color':
                item.link === $route.fullPath ? 'rgb(255 255 255)' : '',
            }"
              link
              v-else-if="$checkPermission(item.permission)"
          >
            <v-list-item-action>
              <v-icon :color="item.link === $route.fullPath ? 'black' : ''">{{
                  item.icon
                }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                  :class="item.link === $route.fullPath ? 'font-weight-bold' : ''"
              >{{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-spacer></v-spacer>
      <template v-slot:append>
        <v-container>
          <v-row>
            <v-col cols="12">
              <!--              <a class=" text-decoration-none grey&#45;&#45;text"-->
              <!--                 href="https://www.youtube.com/watch?v=ZhDhUmIrSNg&feature=youtu.be" target="_blank">-->
              <!--                <p class="mb-0 text-decoration-none grey&#45;&#45;text">Upute za korištenje</p>-->
              <!--              </a>-->
              <router-link
                  class=" text-decoration-none grey--text"
                  style="line-height: 1.2px !important;"
                  to="/admin/upute"
              >
                <p class="mb-0 text-decoration-none grey--text">
                  Upute za korištenje
                </p>
              </router-link>
              <router-link
                  style="line-height: 1.2px !important;"
                  class="pl-2 text-decoration-none grey--text"
                  to="/info"
              >
                <p class="font-weight-regular grey--text">O sustavu</p>
              </router-link>
            </v-col>
            <v-col cols="12" class="mt-0 mb-2 pt-0 pb-2">
              <span class="primary--text" style="font-size: 12px"
              >It always seems impossible until it's done.</span
              >
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-navigation-drawer>

    <v-app-bar
        v-if="!$route.fullPath.startsWith('/admin/print')"
        app
        color="primary"
        dark
        fixed
        style="top: 0 !important;"
        class="print-hide"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
          class="ml-0 pl-4 hidden-sm-and-down"
          style="width: 230px"
      >
        <!-- <span class="hidden-xs-and-down">Next generation</span> -->
        <img
            class="text-center pa-4 mt-2"
            height="70"
            src="@/assets/img/sumit_logo_2.svg"
        />
      </v-toolbar-title>

      <v-select
          v-model="activeRole.model"
          v-show="
          (activeRole.show && $vuetify.breakpoint.smAndUp) ||
            activeRole.forceShow
        "
          :items="activeRole.data"
          @change="
          pickedRole();
          getDemands();
        "
          label="Odaberi ulogu.."
          item-text="role.title"
          item-value="role_id"
          hide-details
          solo-inverted
          :style="{
          marginRight: '10px',
          maxWidth: $vuetify.breakpoint.smAndUp ? '260px' : '150px',
        }"
      ></v-select>

      <v-autocomplete
          v-model="activeSchool.model"
          v-show="activeSchool.show"
          :label="activeSchool.label"
          :items="activeSchool.data"
          :style="{
          marginRight: '10px',
          maxWidth: $vuetify.breakpoint.smAndUp ? '260px' : '190px',
        }"
          @input="
          pickedSchool();
          clearOptionsStorage();
        "
          hide-details
          solo-inverted
      ></v-autocomplete>

      <v-spacer></v-spacer>

      <div>
        <v-btn v-if="this.$getUser().is_impersonating"
               title="Vrati se u svoju ulogu"
               icon
               @click="leaveImpersonate"
        >
          <v-icon class="hidden-md-and-down">mdi-restore</v-icon>
        </v-btn>
        <v-dialog
            v-if="$checkPermission('impersonate user') && !this.$getUser().is_impersonating"
            v-model="impersonateDialog"
            max-width="400px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-2"
                   dark
                   icon
                   v-bind="attrs"
                   v-on="on"
            >
              <v-icon class="hidden-md-and-down"
              >mdi-account-convert-outline
              </v-icon
              >
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">Impersoniziraj se kao</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-text-field
                      v-model="impersonateFieldUserId"
                      type="number"
                      label="Unesite ID korisnika"
                      required
                  ></v-text-field>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red"
                  text
                  @click="impersonateDialog = false"
              >
                Zatvori
              </v-btn>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="sendImpersonateRequest(impersonateFieldUserId)"
              >
                Potvrdi
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>


      <v-menu
          offset-y
          bottom
          origin="center center"
          transition="scale-transition"
          content-class="my-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              class="custom-btn white--text text-capitalize"
              v-long-click="
              () => {
                activeRole.forceShow = true;
              }
            "
              v-bind="attrs"
              v-on="on"
          >
            <v-icon :small="false" :left="$vuetify.breakpoint.mdAndUp"
            >mdi-account-circle
            </v-icon
            >
            {{ $vuetify.breakpoint.mdAndUp ? $getUser().first_name : "" }}
            <!-- prikazi badge ako ima zahtjeva i ako je školski -->
            <v-badge
                v-if="demandsCount > 0 && activeRole.model === 3"
                overlap
                dot
                color="red"
                offset-x="-1"
                offset-y="1"
            >
            </v-badge>
            <v-icon x-small right class="hidden-md-and-down"
            >mdi-menu-down
            </v-icon
            >
          </v-btn>
        </template>

        <v-list style="background-color: rgba(8,71,118,1)">
          <v-list-item :to="'/admin/djelatnik/pregled/' + $getUser().id">
            <v-icon color="white" small left>mdi-account-edit</v-icon>
            <v-list-item-title class="white--text">Profil</v-list-item-title>
          </v-list-item>
          <v-list-item
              class="pr-8"
              v-if="$checkPermission('demand read')"
              to="/admin/zahtjev"
          >
            <v-icon color="white" small left>
              mdi-bell
            </v-icon>
            <v-list-item-title class="white--text">Zahtjevi</v-list-item-title>
            <v-badge
                v-if="demandsCount > 0"
                overlap
                color="red"
                offset-x="-2"
                offset-y="3"
                :content="demandsCount"
            >
            </v-badge>
          </v-list-item>
          <v-list-item @click="performLogout">
            <v-icon color="white" small left>mdi-logout-variant</v-icon>
            <v-list-item-title class="white--text">Odjava</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main class="main-content">
      <v-container
          class="v3_main_container fill-height"
          :class="{ 'pa-0': $vuetify.breakpoint.mdAndDown }"
          fluid
      >
        <v-progress-linear
            v-if="!$route.fullPath.startsWith('/admin/print')"
            :indeterminate="loading"
            height="6"
            class="v3_progress_bar"
        ></v-progress-linear>

        <v-fade-transition mode="out-in">
          <router-view :key="$route.path"></router-view>
        </v-fade-transition>
      </v-container>
    </v-main>

    <snackbar></snackbar>
    <add-dialog></add-dialog>
    <delete-dialog></delete-dialog>
    <message-dialog></message-dialog>
  </div>
  <div v-else>
    <v-navigation-drawer
        v-if="!$route.fullPath.startsWith('/admin/print')"
        v-model="drawer"
        fixed
        app
        color="#F0F5F7"
    >
      <v-row>
        <v-col cols="12">
          <router-link to="/admin">
            <img
                class="text-center pa-4"
                width="100%"
                src="@/assets/img/eMatica_logo.svg"
            />
          </router-link>
        </v-col>
      </v-row>

      <v-select
          outlined
          v-model="school_year_id"
          :items="years"
          item-text="text"
          item-value="id"
          color="primary"
          label="Školska godina"
          hide-details
          dense
          class="mx-3 my-3"
          @change="pickedYear"
      ></v-select>

      <v-list shaped>
        <template v-for="item in items">
          <v-row :key="item.heading" align="center" v-if="item.heading">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col class="text-center" cols="6">
              <a class="body-2 black--text" href="#!">EDIT</a>
            </v-col>
          </v-row>

          <v-list-group
              :key="item.text"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
              v-model="item.model"
              v-else-if="item.children && $checkPermission(item.permission)"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
                :key="i"
                link
                :value="child.link === $route.fullPath"
                v-for="(child, i) in item.children"
                @click="navigate(child)"
            >
              <div v-if="$checkPermission(child.permission)">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.text }}</v-list-item-title>
                </v-list-item-content>
              </div>
            </v-list-item>
          </v-list-group>

          <v-list-item
              :key="item.text"
              :value="item.link === $route.fullPath"
              @click="navigate(item)"
              :style="{
              'background-color':
                item.link === $route.fullPath ? 'rgb(255 255 255)' : '',
            }"
              link
              v-else-if="$checkPermission(item.permission)"
          >
            <v-list-item-action>
              <v-icon :color="item.link === $route.fullPath ? 'black' : ''">{{
                  item.icon
                }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                  :class="item.link === $route.fullPath ? 'font-weight-bold' : ''"
              >{{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-spacer></v-spacer>
      <template v-slot:append>
        <v-container>
          <v-row>
            <v-col cols="12">
              <a
                  class=" text-decoration-none grey--text"
                  href="https://www.youtube.com/watch?v=ZhDhUmIrSNg&feature=youtu.be"
                  target="_blank"
              >
                <p class="mb-0 text-decoration-none grey--text">
                  Upute za korištenje
                </p>
              </a>
              <router-link
                  class="pl-2 text-decoration-none grey--text"
                  to="/info"
              >
                <p class="font-weight-regular grey--text">O sustavu</p>
              </router-link>
            </v-col>
            <v-col cols="12" class="mt-0 mb-2 pt-0">
              <span class="primary--text" style="font-size: 12px"
              >It always seems impossible until it's done.</span
              >
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-navigation-drawer>

    <v-app-bar
        v-if="!$route.fullPath.startsWith('/admin/print')"
        app
        color="primary"
        dark
        fixed
        style="top: 0 !important;"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
          class="ml-0 pl-4 hidden-sm-and-down"
          style="width: 230px"
      >
        <!-- <span class="hidden-xs-and-down">Next generation</span> -->
        <img
            class="text-center pa-4 mt-2"
            height="70"
            src="@/assets/img/sumit_logo_2.svg"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
          offset-y
          bottom
          origin="center center"
          transition="scale-transition"
          content-class="my-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              class="custom-btn white--text text-capitalize"
              v-long-click="
              () => {
                activeRole.forceShow = true;
              }
            "
              v-bind="attrs"
              v-on="on"
          >
            <v-icon :small="false" :left="$vuetify.breakpoint.mdAndUp"
            >mdi-account-circle
            </v-icon
            >
            {{ $vuetify.breakpoint.mdAndUp ? $getUser().first_name : "" }}
            <v-icon x-small right class="hidden-md-and-down"
            >mdi-menu-down
            </v-icon
            >
          </v-btn>
        </template>
        <v-list style="background-color: rgba(8,71,118,1)">
          <!--<v-list-item-->
          <!--:to="'/admin/djelatnik/pregled/' + $getUser().id"-->
          <!--&gt;-->
          <!--<v-icon color="white" small left>mdi-account-edit</v-icon>-->
          <!--<v-list-item-title class="white&#45;&#45;text">Profil</v-list-item-title>-->
          <!--</v-list-item>-->
          <v-list-item @click="performLogout">
            <v-icon color="white" small left>mdi-logout-variant</v-icon>
            <v-list-item-title class="white--text">Odjava</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container
          class="v3_main_container fill-height"
          :class="{ 'pa-0': $vuetify.breakpoint.mdAndDown }"
          fluid
      >
        <div v-if="$route.fullPath == '/admin/' || $route.fullPath == '/admin'">
          <v-container fluid grid-list-md style="padding: 16px 24px 10px 24px;">
            Nemate niti jednu ulogu dodjeljenu u sustavu! Obratite se školskom
            koordinatoru u svojoj školi. Popis školskih koordinatora nalazi se
            na sljedećoj
            <a href="https://skole.sum.ba/skole" target="_blank">poveznici</a>.
          </v-container>
        </div>
        <!--<v-fade-transition mode="out-in">-->
        <!--<router-view :key="$route.path"></router-view>-->
        <!--</v-fade-transition>-->
      </v-container>
    </v-main>
  </div>
</template>

<script>
import {serverBus} from "../main";
import AddDialog from "../components/add/AddDialog";
import Snackbar from "../components/custom/Snackbar";
import DeleteDialog from "../components/dialogs/DeleteDialog";
import MessageDialog from "../components/dialogs/MessageDialog";
import ApiV2 from "../services/ApiV2";

const baseUrl = process.env.VUE_APP_SKOLE_API_URL;

export default {
  components: {
    Snackbar,
    AddDialog,
    DeleteDialog,
    MessageDialog,
  },
  watch: {
    $route: function () {
      if (
          !this.$route.path.includes("korisnik") &&
          !this.$route.path.includes("djelatnik")
      ) {
        localStorage.removeItem("korisnik");
      }
      if (!this.$route.path.includes("ucenik")) {
        localStorage.removeItem("student-options");
      }
      if (!this.$route.path.includes("skola")) {
        localStorage.removeItem("school-options");
      }
      if (!this.$route.path.includes("djelatnik")) {
        localStorage.removeItem("employee-options");
      }
      if (!this.$route.path.includes("predmeti")) {
        localStorage.removeItem("subject-options");
      }
      if (!this.$route.path.includes("nastavni_planovi")) {
        localStorage.removeItem("plans-options");
      }
      if (!this.$route.path.includes("skolska_godina")) {
        localStorage.removeItem("skolska_godina");
      }
      if (!this.$route.path.includes("opcina")) {
        localStorage.removeItem("opcina");
      }
      if (!this.$route.path.includes("svrha_potvrde")) {
        localStorage.removeItem("svrha_potvrde");
      }
      if (!this.$route.path.includes("zupanija")) {
        localStorage.removeItem("canton-options");
      }
      if (!this.$route.path.includes("uloga")) {
        localStorage.removeItem("uloga");
      }
      if (!this.$route.path.includes("dozvola")) {
        localStorage.removeItem("dozvola");
      }
      if (
          !this.$route.path.includes("djelatnici_radionice") &&
          !this.$route.path.includes("djelatnik")
      ) {
        localStorage.removeItem("workshop_search");
        localStorage.removeItem("selected_workshop");
      }
      if (!this.$route.path.includes("odjeljenje/pregled")) {
        localStorage.removeItem("department-tab");
        localStorage.removeItem("department-students");
        localStorage.removeItem("department-subjects");
      }
    },
  },
  created() {
    document.title = "SUMIT matica";
    this.getLoggedInUser();


    let self = this;

    serverBus.$on("impersonate-user", (userId) => {
      this.sendImpersonateRequest(userId)
    });

    serverBus.$on("change-demands-count", (count) => {
      this.demandsCount = count;
    });

    serverBus.$on("logged-in-out", (loggedIn) => {
      self.loggedIn = loggedIn;

      if (!self.loggedIn) {
        this.$store.commit("setUser", {});
        this.$store.commit("setPermissions", []);

        this.clearLocalStorage();
        let apiUrl = process.env.VUE_APP_SKOLE_API_URL;
        let host = `${window.location.protocol}//${location.host}`;
        window.location.href = `${apiUrl}sso/logout?redirect_to=${host}`;
      }
    });

    this.getDemands();

    serverBus.$on("get-permissions", () => {
      this.getPermissions();
    });

    serverBus.$on("perform-layout-loading", (loading) => {
      this.loading = loading;
    });

    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 27) {
        // Escape
        serverBus.$emit("close-add-view-dialog");
        serverBus.$emit("close-edit-role-dialog");
        serverBus.$emit("close-delete-item-dialog");
        serverBus.$emit("close-user-roles-dialog");
      }
    });
  },
  mounted() {
    let sessionExpired =
        new Date() > new Date(localStorage.getItem("session_expires"));

    this.loggedIn = localStorage.getItem("token") !== "-1" && !sessionExpired;

    if (sessionExpired) {
      this.loggedIn = false;

      localStorage.setItem("token", "-1");
    }

  },

  methods: {
    getPermissions: function () {
      this.$axios
          .post("ostalo/dozvole")
          .then((response) => {
            this.$store.commit("setPermissions", response.data);
          })
          .catch(() => {
            serverBus.$emit("logged-in-out", false);
          });
    },
    async leaveImpersonate() {
      ApiV2.defaults.baseURL = baseUrl + 'v2/'
      await ApiV2.get('impersonate/leave');
      this.clearLocalStorage();
      location.reload();
    },

sendImpersonateRequest: async function (userId) {
      ApiV2.defaults.baseURL = baseUrl + 'v2/'
      await ApiV2.get('impersonate/take/' + userId);
      this.impersonateDialog = false;
      this.clearLocalStorage();
      location.reload();
    },

    async getSchoolYears() {

      let {data} = await ApiV2.get('school_years', {
        params: {
          sortBy: 'date_from',
          sortDesc: 1
        }
      })
      this.years = data.data.filter(year => year.visible === 'Da');
      if (isNaN(this.school_year_id) && this.years.length > 0) {
        this.school_year_id = this.years.filter(y => y.active == 'Da')[0].id;
        this.pickedYear()
      }
    },

    pickedYear() {
      localStorage.setItem('school_year_id', this.school_year_id)
      serverBus.$emit("reload-all-data");
    },

    getDemands() {
      /* ako je školski get demands */
      if (this.currentRole.role_id === 3) {
        ApiV2.get("demands").then((response) => {
          this.demandsCount = response.data.total;
        });
      }
    },

    navigate: function (item) {
      for (let i = 0; i < this.items.length; i++) this.items[i].active = false;

      item.active = true;

      switch (item.link) {
        default:
          this.$navigate(item.link);
          break;
      }
    },

    clearLocalStorage: function () {
      localStorage.removeItem("role_id");
      localStorage.removeItem("organisation_id");
      localStorage.removeItem("organisation_type");
      localStorage.removeItem("school_year_id");
      localStorage.removeItem(this.$getTable());
      localStorage.removeItem("student-options");
      localStorage.removeItem("school-options");
      localStorage.removeItem("employee-options");
      localStorage.removeItem("canton-options");
      localStorage.removeItem("plans-options");
      localStorage.removeItem("subject-options");
    },
    clearOptionsStorage() {
      localStorage.removeItem(this.$getTable());
      localStorage.removeItem("student-options");
      localStorage.removeItem("school-options");
      localStorage.removeItem("employee-options");
      localStorage.removeItem("canton-options");
      localStorage.removeItem("plans-options");
      localStorage.removeItem("subject-options");
    },
    performLogout: function () {
      serverBus.$emit("logged-in-out", false);
    },

    pickedRole() {
      localStorage.setItem("role_id", this.activeRole.model);

      let self = this;
      let currentRole = this.$getUser().model_roles.find((role) => {
        return role.role_id === self.activeRole.model;
      });

      this.$store.dispatch("setCurrentRole", currentRole);

      if (currentRole) {
        localStorage.setItem(
            "organisation_type",
            currentRole.organisation_type
        );

        if (currentRole.organisation_type === "Everything") {
          localStorage.setItem("organisation_id", 1);
        } else {
          localStorage.setItem("organisation_id", currentRole.organisation_id);
        }

        this.activeRole.organisationType = currentRole.organisation_type;
        this.activeSchool.data = currentRole.schools;

        if (
            ["Everything", "Canton", "Township"].includes(
                currentRole.organisation_type
            )
        )
          this.activeSchool.data.unshift({
            text: "Prikaži sve škole",
            value: -1,
          });

        if (
            this.activeRole.data.length === 1 &&
            this.activeSchool.data.length === 1
        ) {
          this.activeRole.show = false;
          this.activeSchool.show = true;
        } else {
          this.activeRole.show = !(
              this.activeRole.data.length === 1 &&
              this.activeSchool.data.length > 1
          );
          // this.activeSchool.show = !(this.activeSchool.data.length === 1 && this.activeRole.data.length > 1);
        }

        if (this.activeSchool.data.length > 0) {
          this.activeSchool.model = this.activeSchool.data[0].value;
        }

        let preselectedSchool = parseInt(localStorage.getItem("school_id"));
        let availableSchools = currentRole.schools.map((item) => item.value);

        if (availableSchools.includes(preselectedSchool))
          this.activeSchool.model = preselectedSchool;
        else this.activeSchool.model = availableSchools[0];

        this.pickedSchool();
      }

      this.readyToUse = true;
    },

    pickedSchool() {
      this.$store.dispatch("getSchool", this.activeSchool.model);
      localStorage.setItem("school_id", this.activeSchool.model);

      if (this.activeRole.organisationType === "School") {
        localStorage.setItem("organisation_id", this.activeSchool.model);
      }

      serverBus.$emit("get-permissions");
      serverBus.$emit("reload-all-data");
    },

    async getLoggedInUser() {
      if (this.school_year_id == null) {
        this.school_year_id = parseInt(localStorage.getItem("school_year_id"));
      }
      await this.getSchoolYears();
      await this.$store.dispatch("getUser")

      this.activeRole.data = this.$getUser().model_roles;

      if (this.activeRole.data.length > 0) {
        this.activeRole.model = parseInt(localStorage.getItem("role_id"));

        if (isNaN(this.activeRole.model))
          this.activeRole.model = this.activeRole.data[0].role_id;

        this.pickedRole();
        this.getPermissions();
      }
    },
  },

  computed: {
    items: function () {
      let items = [
        {
          icon: "mdi-view-dashboard",
          text: "Naslovnica",
          link: "/admin/",
          permission: "for everyone",
        },
        {
          icon: "mdi-tag-faces",
          text: "Učenici",
          link: "/admin/ucenik",
          permission: "users index",
        },
        {
          icon: "mdi-clipboard-account",
          text: "Djelatnici",
          link: "/admin/djelatnik",
          permission: "users index",
        },
        {
          icon: "mdi-account-multiple",
          text: "Odjeli",
          link: "/admin/odjeljenje",
          permission: "departments index all",
        },
        {
          icon: "mdi-domain",
          text: "Škole",
          link: "/admin/skola",
          permission: "schools index",
        },
        {
          icon: "mdi-bookshelf",
          text: "Predmeti",
          link: "/admin/predmeti",
          permission: "subjects index",
        },
        {
          icon: "mdi-clipboard-file-outline",
          text: "Nastavni planovi",
          link: "/admin/nastavni_planovi",
          permission: "school_plans index",
        },
        {
          icon: "mdi-clipboard-arrow-right-outline",
          text: "Smjerovi",
          link: "/admin/smjerovi",
          permission: "educational_fields index",
        },
        {
          icon: "mdi-calendar",
          text: "Školska godina",
          link: "/admin/skolska_godina",
          permission: "school_years index",
        },
        {
          icon: "mdi-account-group-outline",
          text: "Korisnici",
          link: "/admin/pregled/korisnik",
          permission: "educational_fields index",
        },
        {
          icon: "mdi-file-document-edit-outline",
          "icon-alt": "mdi-file-document-edit-outline",
          text: "Izvještaji",
          model: false,
          permission: "reports sidebar",
          children: [
            {
              text: "Županijski koordinatori",
              link: "/admin/izvjestaj/zupanijski_koordinatori",
              permission: "educational_fields index",
            },
            {
              text: "SUMIT koordinatori",
              link: "/admin/izvjestaj/sumit_koordinatori",
              permission: "reports sumit coordinators",
            },
            {
              text: "Radionice",
              link: "/admin/izvjestaj/djelatnici_radionice",
              permission: "reports workshops",
            },
            {
              text: "Dodjeljeni eduID",
              link: "/admin/izvjestaj/dodjeljeni_eduid",
              permission: "reports eduID",
            },
            {
              text: "Nastavnici - predmeti",
              link: "/admin/izvjestaj/nastavnici_predmeti",
              permission: "reports teachers-subjects",
            },
            {
              text: "Opći uspjeh učenika u učenju",
              link: "/admin/izvjestaj/ucenici_ucenje",
              permission: "reports success in learning",
            },
            {
              text: "Opći uspjeh učenika u vladanju",
              link: "/admin/izvjestaj/ucenici_vladanje",
              permission: "reports behavioral success",
            },
            {
              text: "Uspjeh učenika iz nastavnih predmeta",
              link: "/admin/izvjestaj/ostvarenje_plana",
              permission: "reports subject success",
            },
            {
              text: "Broj profesora po školama u županiji",
              link: "/admin/izvjestaj/profesori_po_zupanijama",
              permission: "number_of_teachers_by_canton",
            },
            {
              text: "Broj učenika po školama u županiji",
              link: "/admin/izvjestaj/studenti_po_zupanijama_popis",
              permission: "number_of_students_by_canton",
            },
            // {text: 'Školski planovi', link: '/admin/izvjestaj/izvjestaji_skolski_planovi', permission: 'schools index'},
            // {text: 'Odslušane radionice', link: '/admin/zupanija', permission: 'educational_fields index'},
          ],
        },
        {
          icon: "mdi-earth-arrow-right",
          "icon-alt": "mdi-earth",
          text: "Ostalo",
          model: false,
          permission: "townships index",
          children: [
            {
              text: "Općine",
              link: "/admin/opcina",
              permission: "townships index",
            },
            {
              text: "Županije",
              link: "/admin/zupanija",
              permission: "cantons index",
            },
          ],
        },
        {
          icon: "mdi-lock-open-variant-outline",
          "icon-alt": "mdi-lock-open-outline",
          text: "Pristup",
          model: false,
          permission: "roles index",
          children: [
            {
              text: "Uloge",
              link: "/admin/pregled/uloga",
              permission: "roles index",
            },
            {
              text: "Dozvole",
              link: "/admin/pregled/dozvola",
              permission: "permissions index",
            },
          ],
        },
      ];

      /* ako je odabrana škola prikaži moja škola */
      if (this.school)
        items.splice(1, 0, {
          icon: "mdi-home-city-outline",
          text: "Moja škola",
          link: "/admin/moja_skola",
          permission: "my_school index",
        });

      /* ako je tajnik i skola mu je u srednjoj bosni */
      if (this.currentRole.role_id === 7 && (this.cantonForSecretary === 5 || this.cantonForSecretary === 9)) {
        items.splice(1, 0, {
          icon: "mdi-note-plus-outline",
          text: "Svrhe potvrda",
          link: "/admin/svrha_potvrde",
          permission: "certificates_of_regular_education_types index",
        });
      }

      /* ako je razrednik prikaži moje odjeljenje */
      if (this.currentRole.role_id === 5) {
        const school = this.$getUser()
            .model_roles.find((model) => model.role_id === 5)
            .schools.find((school) => school.value === this.school.id);

        if (school) {
          const headroomDepartments = school.headroom_departments;

          if (headroomDepartments.length < 1) {
            items.splice(1, 0, {
              icon: "mdi-clipboard-outline",
              text: "Moj odjel",
              link: `/admin/odjeljenje/pregled/none`,
              permission: "my department view",
            });
          } else if (headroomDepartments.length === 1) {
            items.splice(1, 0, {
              icon: "mdi-clipboard-outline",
              text: "Moj odjel",
              link: `/admin/odjeljenje/pregled/${headroomDepartments[0].id}`,
              permission: "my department view",
            });
          } else {
            /* ako razrednik ima više odjeljenja kreiraj list children s nazivima odjeljenja */
            let children = [];

            headroomDepartments.forEach((department) => {
              children.push({
                text: department.label,
                link: `/admin/odjeljenje/pregled/${department.id}`,
                permission: "my department view",
              });
            });

            items.splice(1, 0, {
              icon: "mdi-clipboard-outline",
              "icon-alt": "mdi-clipboard-outline",
              text: "Moj odjel",
              permission: "my department view",
              children: children,
            });
          }
        }
      }

      return items;
    },
    school() {
      return this.$store.getters.getSchool;
    },
    currentRole() {
      return this.$store.getters.getCurrentRole;
    },
    cantonForSecretary() {
      return this.$store.getters.getSchool?.canton?.id;
    },
  },

  data: () => ({
    loggedIn: false,
    drawer: null,
    dialog: false,
    impersonateDialog: false,
    loading: false,
    school_year_id: null,
    years: [],
    readyToUse: false,
    demandsCount: 0,
    impersonateFieldUserId: null,
    activeRole: {
      model: -1,
      show: true,
      forceShow: false,
      data: [],
    },
    activeSchool: {
      model: {},
      label: "",
      data: [],
      show: true,
    },
  }),
};
</script>

<style>
.v3_main_container {
  padding: 0;
}

.v3_index_view {
  padding: 34px 34px 20px 34px;
}

.v3_progress_bar {
  position: fixed !important;
  z-index: 4;
  padding: 0;
  margin: 0;
}

.v3_heading_mobile_view {
  padding: 10px 14px 10px 10px;
}

.v-navigation-drawer {
  top: 0 !important;
}

.v-data-table {
  border: 1px solid #e6dddd;
  border-radius: 0 !important;
}

.container.fill-height {
  align-items: baseline;
}

.v-data-table-header th {
  white-space: nowrap;
}

.custom-btn {
  border: 1px rgba(255, 255, 255, 0.12) solid !important;
  border-radius: 5px;
}

.custom-btn::before {
  border: 1px white solid !important;
}

.v-navigation-drawer__append,
.v-navigation-drawer__append .container,
.v-navigation-drawer__append .col-12 {
  padding-bottom: 0;
}

.v-snack__content {
  color: white;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(240, 245, 247, 0.5);
}

thead {
  background-color: #f0f5f7;
}

.v-data-table {
  width: 100%;
  border: none;
  border-bottom: 1px solid #cccccc;
  border-radius: 0 !important;
}

td {
  height: 52px !important;
  font-size: 16px !important;
  border: none !important;
}

th {
  height: 36px !important;
  font-size: 14px !important;
  border: none !important;
  font-weight: 500 !important;
  color: #000 !important;
  padding: 14px !important;
}

td:not(:first-child) {
  font-weight: 300;
}

.v-pagination__navigation,
.v-pagination__item {
  box-shadow: none !important;
  border: 1px solid #dddddd;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: #f0f5f7;
}

::-webkit-scrollbar-thumb {
  background: #dee7ea;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #ced7da;
}

.v-slide-group__prev {
  display: none !important;
}
</style>

<style lang="scss">
/* Print */
@media print {
  .bel{
        position:fixed;
        top:0;
   }
  .title{
    position:fixed;
    top:190px;
    text-align: center;
  }
  .print-show {
    display: block !important;
  }

  .v-content {
    padding: 0 !important;
  }

  .print-hide,
  .v-btn {
    display: none !important;
  }

  .print-hide,
  .v-dialog {
    display: none !important;
  }

  .main-content {
    padding: 0 !important;
  }
  .print-show-flex {
    display: flex !important;
  }
  .data_table {

    position: fixed;
    top: 230px;

    tr {
      display: block;
      border-bottom: 1px solid black;
      border-top: none;
      border-right: none;
      border-left: none;

    }

    td {
      text-align: center;
      height: 15px !important;
      width: 1000px;
      padding-left: 70px;
      padding-top: 100px;
      font-size: 15px !important;
      border: none;
    }

    tr th:first-child {
      width: 70% !important;
    }

    tr td:first-child {
      width: 70% !important;
    }

    tr td:not(:first-child) {
      width: 500px !important;
    }

    tr th:not(:first-child) {
      width: 500px !important;
    }
  }

  .data_table1 {

           position:fixed;
           top:230px;

           tr {
             display: block;
             border-bottom: 1px solid black;
             border-top: none;
             border-right: none;
             border-left: none;

           }
           td {
             text-align: center;
             height: 15px !important;
             width: 1000px;
             padding-left: 70px;
             padding-top: 100px;
             font-size: 12px !important;
             border: none;
           }

           tr th:first-child {
             width: 70% !important;
           }

           tr td:first-child {
             width: 70% !important;
           }

           tr td:not(:first-child) {
             width: 500px !important;
           }

           tr th:not(:first-child) {
             width: 500px !important;
           }
         }
  .data_table3 {

    position:fixed;
    top:230px;

    tr {
      display: block;
      border-bottom: 1px solid black;
      border-top: none;
      border-right: none;
      border-left: none;

    }
    td {
      text-align: center;
      height: 20px !important;
      width: 150px;
      font-size: 15px !important;
      border: none;
    }

    tr th:first-child {
      width: 30% !important;
    }

    tr td:first-child {
      width: 30% !important;
    }

    tr td:not(:first-child) {
      width: 80px !important;
    }

    tr th:not(:first-child) {
      width: 80px !important;
    }
  }
}

.print-show {
  display: none;
}

.print-show-flex {
  display: none;
}

@page {
  size: auto;
  margin: 0;
  margin-top: 30px;
}
.bottom-footer {
             font-size: 11px;
             text-align: center;
            position:fixed;
             bottom:25px;
            }
.description {
  font-size: 11px;
  text-align: center;
  position:fixed;
  bottom:100px;
}
    .bottom-footer1 {
             font-size: 9px;
            text-align: center;
              position:fixed;
           bottom:5px;
           }
</style>
